import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs';
import { PageCO, PageCategoryCO, PageCategoryType } from 'src/app/shared/models/ApiModels';
import { PageDataService } from 'src/app/shared/services/page-data.service';
import { ApiUrls } from 'src/app/shared/const/Api-urls';
import { SchoolMapService } from 'src/app/shared/services/school-map.service';

@Component({
  selector: 'app-pub-disclosure',
  templateUrl: './pub-disclosure.component.html',
  styleUrls: ['./pub-disclosure.component.scss']
})
export class PubDisclosureComponent implements OnInit {

  page?: PageCO;

  /** GENERAL INFORMATION (HTML from backend) */
  generalInfoHtml = '';

  /** Remaining categories */
  categories: PageCategoryCO[] = [];

  displayedColumnsDocs = ['slno', 'information', 'link'];

  constructor(
    private pageDataService: PageDataService,
    private schoolMapService: SchoolMapService
  ) {}

  ngOnInit(): void {
    this.pageDataService.loadPageData();
  }

  pageData$ = this.pageDataService.pageData$.pipe(
    tap(data => {
      if (!data?.length) return;

      // adjust index if needed
      this.page = data[2];

      const categoryMap = new Map<PageCategoryType, PageCategoryCO>();
      this.page.category?.forEach(cat => categoryMap.set(cat.category, cat));

      /** GENERAL INFORMATION */
      this.generalInfoHtml =
        categoryMap.get(PageCategoryType.GENERAL_INFO)?.content?.[0]?.content ?? '';

      /** OTHER SECTIONS (B–E) */
      this.categories = this.page.category?.filter(
        c => c.category !== PageCategoryType.GENERAL_INFO
      ) ?? [];

      // console.log(this.generalInfoHtml, this.categories)
    })
  );

  /** Section letters: B, C, D, E */
  getSectionLabel(index: number): string {
    return String.fromCharCode(66 + index);
  }

  getFileUrl(uuid: string): string {
    return this.schoolMapService.getOrigin() + ApiUrls.publicDisclosureFilePath + uuid;
  }

  viewFile1: any;

  viewFile(file: any): void {
    this.viewFile1 = {...file};console.log(this.viewFile1)
  }

  updateVieFile1(): void {
    this.viewFile1 = null;
  }
}
